import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { HelpContentDataSource } from './help-content-data-source';
import { HelpPage } from '../../models/help/help-page.model';
import { FaqPage } from '../../models/help/faq.model';
import { Certification, CertificationsListResponse } from '../../models/help/certification.model';
import { SalesChannelsPage } from '../../models/help/sales-channel.model';

/**
 * JSON file-based help content data source.
 * Reads from /content/ayuda/*.json files.
 */
@Injectable()
export class JsonHelpContentDataSource extends HelpContentDataSource {
  private readonly basePath = '/content/ayuda';
  private readonly certPath = `${this.basePath}/certificaciones`;

  constructor(private readonly http: HttpClient) {
    super();
  }

  getPage(slug: string): Observable<HelpPage> {
    return this.http.get<HelpPage>(`${this.basePath}/${slug}.json`);
  }

  getFaq(): Observable<FaqPage> {
    return this.http.get<FaqPage>(`${this.basePath}/preguntas-frecuentes.json`);
  }

  getSalesChannels(): Observable<SalesChannelsPage> {
    return this.http.get<SalesChannelsPage>(`${this.basePath}/canales-venta.json`);
  }

  getCertifications(): Observable<Certification[]> {
    return this.http
      .get<CertificationsListResponse>(`${this.basePath}/certificaciones.json`)
      .pipe(map((res) => res.certifications));
  }

  getCertificationBySlug(slug: string): Observable<Certification | HelpPage> {
    return this.http.get<Certification | HelpPage>(`${this.certPath}/${slug}.json`);
  }
}
